import { useEffect, useState } from 'react'
import { Icon } from 'assets/index'
import { MainContainer, Option, Checkbox } from './styles'

interface IProps {
  options: any[]
  setSelected: any
  placeholder: string
  icon: any
  selected: any[]
  dataTestId: string
  hasCheckbox?: boolean
  disabled?: boolean
}

const FilterMulti = (props: IProps) => {
  const {
    options,
    setSelected,
    icon,
    placeholder,
    selected,
    dataTestId,
    hasCheckbox,
    disabled = false,
  } = props
  const [optFilter, setOptFilter] = useState<any>('')
  const [focused, setFocused] = useState(false)
  const [filteredOptions, setFilteredOptions] = useState(options)

  useEffect(() => {
    setFilteredOptions(
      options.filter(
        (opt) =>
          opt.label && opt.label.toLowerCase().includes(optFilter.toLowerCase())
      )
    )
  }, [optFilter, options])

  // Função para verificar se um item já foi selecionado
  const isSelected = (opt: any) => {
    if (!Array.isArray(selected)) return false
    return selected.some((item) => item.value === opt.value)
  }

  return (
    <MainContainer disabled={disabled}>
      <img className="filter-icon" src={icon} alt="filter icon" />
      <input
        data-testid={dataTestId}
        className="filter-input"
        type="text"
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setTimeout(() => {
            setFocused(false)
            setOptFilter('')
          }, 300)
        }}
        placeholder={placeholder}
        disabled={disabled}
        value={optFilter}
        onChange={(e) => {
          setOptFilter(e.target.value)
        }}
      />

      <img
        className="chrevon-down"
        src={Icon('chevron_down.svg')}
        alt="filter icon"
      />
      {focused && (
        <div className="menu">
          {filteredOptions.length === 0 && (
            <div
              style={{
                padding: '10px',
                fontSize: '12px',
                color: '#777',
                textAlign: 'center',
              }}
            >
              Sem opções
            </div>
          )}
          {filteredOptions.map((opt) => (
            <Option
              data-testid={`option-${opt.label}`}
              type="button"
              key={opt.value}
              className="option"
              value={opt.value}
              isSelected={isSelected(opt)}
              onClick={() => {
                if (isSelected(opt)) {
                  setSelected((prevSelected: any[]) =>
                    prevSelected.filter(
                      (item) => item.value !== opt.value // Comparando pelo `value`
                    )
                  )
                } else {
                  setSelected((prevSelected: any) => [...prevSelected, opt])
                }
              }}
            >
              {hasCheckbox && (
                <Checkbox>
                  <input
                    type="checkbox"
                    checked={isSelected(opt)}
                    onChange={() => null}
                    className="original-checkbox"
                  />
                  <span className="custom-checkbox" />
                </Checkbox>
              )}
              {opt.label}
            </Option>
          ))}
        </div>
      )}
    </MainContainer>
  )
}

export default FilterMulti
